export enum ApiKeyApiErrorTypes {
  ServiceUnavailableError,
  NotFoundError,
}

export class ApiKeyApiError {
  constructor(public type: ApiKeyApiErrorTypes, public error: Error) {}
}
